export default __webpack_public_path__ + "static/N0096-50d1d3a560d68bc778391c1b09f89ecc.png";